// @generated by protoc-gen-es v1.3.3 with parameter "target=js+dts,import_extension=none"
// @generated from file merchant/v1/public_payment_links_api.proto (package merchant.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";
import { LinkItem, LinkStatus, PaymentLink } from "./payment_link_pb";
import { Timestamp } from "../../google/protobuf/timestamp_pb";
import { Shopper } from "../../common/v1/shopper_pb";
import { PaymentLinkCheckoutOptions, SendTo } from "../../common/v1/common_pb";
import { Cart } from "./cart_pb";

/**
 * next number: 10
 *
 * @generated from message merchant.v1.CreateLinkRequest
 */
export const CreateLinkRequest = proto3.makeMessageType(
  "merchant.v1.CreateLinkRequest",
  () => [
    { no: 1, name: "merchant_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "description", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "items", kind: "message", T: LinkItem, repeated: true },
    { no: 5, name: "expiration_timestamp", kind: "message", T: Timestamp },
    { no: 6, name: "customer", kind: "message", T: Shopper },
    { no: 7, name: "currency_code", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "total_transaction_amount", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 9, name: "checkout_options", kind: "message", T: PaymentLinkCheckoutOptions },
    { no: 10, name: "send_to", kind: "message", T: SendTo },
    { no: 11, name: "cart", kind: "message", T: Cart },
    { no: 12, name: "purchase_order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message merchant.v1.CreateLinkResponse
 */
export const CreateLinkResponse = proto3.makeMessageType(
  "merchant.v1.CreateLinkResponse",
  () => [
    { no: 1, name: "link", kind: "message", T: PaymentLink },
  ],
);

/**
 * @generated from message merchant.v1.ListLinksRequest
 */
export const ListLinksRequest = proto3.makeMessageType(
  "merchant.v1.ListLinksRequest",
  () => [
    { no: 1, name: "page_size", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: "page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "filter", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "order_by", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message merchant.v1.ListLinksResponse
 */
export const ListLinksResponse = proto3.makeMessageType(
  "merchant.v1.ListLinksResponse",
  () => [
    { no: 1, name: "links", kind: "message", T: PaymentLink, repeated: true },
    { no: 2, name: "next_page_token", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message merchant.v1.UpdateLinkRequest
 */
export const UpdateLinkRequest = proto3.makeMessageType(
  "merchant.v1.UpdateLinkRequest",
  () => [
    { no: 1, name: "link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "status", kind: "enum", T: proto3.getEnumType(LinkStatus) },
  ],
);

/**
 * @generated from message merchant.v1.UpdateLinkResponse
 */
export const UpdateLinkResponse = proto3.makeMessageType(
  "merchant.v1.UpdateLinkResponse",
  () => [
    { no: 1, name: "link", kind: "message", T: PaymentLink },
  ],
);

/**
 * @generated from message merchant.v1.GetLinkRequest
 */
export const GetLinkRequest = proto3.makeMessageType(
  "merchant.v1.GetLinkRequest",
  () => [
    { no: 1, name: "link_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message merchant.v1.GetLinkResponse
 */
export const GetLinkResponse = proto3.makeMessageType(
  "merchant.v1.GetLinkResponse",
  () => [
    { no: 1, name: "link", kind: "message", T: PaymentLink },
  ],
);

